import { createContext , useState } from "react";

export const ContactContext = createContext();
export const ContactProvider = ({children}) => {
    const [isContactOpen, setIsContactOpen] = useState(null);
    return (
        <ContactContext.Provider value={{isContactOpen, setIsContactOpen}}>
            {children}
        </ContactContext.Provider>
    )
}